import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';

export function MotivationCard() {
  return (
    <section className="relative flex min-h-60 min-w-0 flex-col justify-between overflow-hidden rounded-2xl border border-info/20 bg-gradient-to-br from-info-subtle/80 via-accent-subtle/70 to-accent-subtle/60 p-5 shadow-xs">
      <div className="flex size-9 items-center justify-center rounded-lg bg-accent-subtle/80 text-accent">
        <Calendar className="size-4" />
      </div>

      <div className="z-10 mt-3">
        <h2 className="font-display text-base font-extrabold leading-tight text-fg">
          Stay Focused,
          <br />
          Stay Ahead
        </h2>
        <p className="mt-2 text-xs font-medium text-fg-muted">
          Your goals, your journey,
          <br />
          our support.
        </p>
      </div>

      <Link
        to="/performance"
        className="z-10 mt-4 inline-flex w-fit items-center rounded-lg bg-accent px-4 py-2 text-xs font-bold text-white shadow-xs hover:bg-accent-hover transition-all"
      >
        View Performance →
      </Link>

      {/* Mountain peaks with flag graphic matching mockup */}
      <svg
        viewBox="0 0 200 120"
        className="pointer-events-none absolute bottom-0 right-0 w-4/5 text-accent"
        aria-hidden="true"
      >
        {/* Mountain 1 background */}
        <polygon points="20,120 100,50 180,120" style={{ fill: 'var(--hero-3)' }} opacity="0.3" />
        {/* Mountain 2 foreground */}
        <polygon points="70,120 150,25 210,120" style={{ fill: 'var(--accent)' }} opacity="0.45" />
        {/* Flag pole on peak */}
        <line
          x1="150"
          y1="25"
          x2="150"
          y2="10"
          style={{ stroke: 'var(--accent-hover)' }}
          strokeWidth="1.5"
        />
        {/* Flag triangle */}
        <polygon points="150,10 162,14 150,18" style={{ fill: 'var(--accent-hover)' }} />
      </svg>
    </section>
  );
}
